import React, {useEffect} from 'react';



let LevelSelect = ({currentFilters, setFilters}) => {


  useEffect (() => {
    let minRangeValueGap = 0;
    const range = document.getElementById("range_track");
    const minval = document.querySelector(".minvalue");
    const maxval = document.querySelector(".maxvalue");
    const rangeInput = document.querySelectorAll("input");

    let minRange, maxRange, minPercentage, maxPercentage;

    const minRangeFill = () => {
      range.style.left = (rangeInput[0].value / rangeInput[0].max) * 100 + "%";
    };
    const maxRangeFill = () => {
      range.style.right =
        100 - (rangeInput[1].value / rangeInput[1].max) * 100 + "%";
    };
    const MinValueBubbleStyle = () => {
      minPercentage = (minRange / rangeInput[0].max) * 100;
      minval.style.left = minPercentage + "%";
      minval.style.transform = `translate(-${minPercentage / 2}%, -100%)`;
    };
    const MaxValueBubbleStyle = () => {
      maxPercentage = 100 - (maxRange / rangeInput[1].max) * 100;
      maxval.style.right = maxPercentage + "%";
      maxval.style.transform = `translate(${maxPercentage / 2}%, 100%)`;
    };

    const setMinValueOutput = () => {
      minRange = parseInt(rangeInput[0].value);
      minval.innerHTML = rangeInput[0].value;
    };
    const setMaxValueOutput = () => {
      maxRange = parseInt(rangeInput[1].value);
      maxval.innerHTML = rangeInput[1].value;
    };

    setMinValueOutput()
    setMaxValueOutput()
    minRangeFill()
    maxRangeFill()
    MinValueBubbleStyle()
    MaxValueBubbleStyle()

    rangeInput.forEach((input) => {
      input.addEventListener("input", (e) => {
        setMinValueOutput();
        setMaxValueOutput();

        minRangeFill();
        maxRangeFill();

        MinValueBubbleStyle();
        MaxValueBubbleStyle();

        if (maxRange - minRange < minRangeValueGap) {
          if (e.target.className === "min") {
            rangeInput[0].value = maxRange - minRangeValueGap;
            setMinValueOutput();
            minRangeFill();
            MinValueBubbleStyle();
            if (rangeInput[0].value === rangeInput[0].max)
            e.target.style.zIndex = "2"
          }
          else {
            rangeInput[1].value = minRange + minRangeValueGap;
            e.target.style.zIndex = "2"
            setMaxValueOutput();
            maxRangeFill();
            MaxValueBubbleStyle();
          }
        } else if (maxRange - minRange === minRangeValueGap) {
          if (e.target.className === "min") {
            setMinValueOutput();
            minRangeFill();
            MinValueBubbleStyle();
            if (rangeInput[0].value === rangeInput[0].max)
            e.target.style.zIndex = "2"
          }
          else {
            e.target.style.zIndex = "2"
            setMaxValueOutput();
            maxRangeFill();
            MaxValueBubbleStyle();
          }
        }
      });
    });
  });

  let updateMin = (lo) => {
    let newFilters = {...currentFilters}
    newFilters["level-lo"] = lo.target.value;
    setFilters(newFilters);
  };

  let updateMax = (hi) => {
    let newFilters = {...currentFilters}
    newFilters["level-hi"] = hi.target.value;
    setFilters(newFilters);
  };



  return (
    <div className="level-slide">
      <div className="double_range_slider_box">
        <div className="double_range_slider">
          <span className="range_track" id="range_track"></span>

          <input type="range" className="range min" min="0" max="9" defaultValue="0" step="0" onChange={updateMin} />
          <input type="range" className="range max" min="0" max="9" defaultValue="9" step="0" onChange={updateMax} />

          <div className="minvalue"></div>
          <div className="maxvalue"></div>
        </div>
      </div>
    </div>
  )
};

export default LevelSelect;